export default "__VITE_ASSET__BifaWVuA__"